module.exports = __webpack_public_path__ + "assets/img/pro_1.76b22fe7.png";